import { Button, SimpleDialog, Typography } from "@powerdiary/components-library/lib";

export interface IAlertProps {
    title?: string;
    text?: string;
    yesButtonTitle?: string;
    yesButtonCallback?: () => void;
    onModalClosed?: () => void;
}

export const AlertDialog = ({ text, yesButtonTitle, yesButtonCallback, onModalClosed }: IAlertProps) => {
    const renderActions = () => (
        <>
            <Button variant="contained" size="medium" onClick={yesButtonCallback}>
                {yesButtonTitle || "Ok"}
            </Button>
        </>
    );

    return (
        <SimpleDialog
            open
            handleClose={onModalClosed}
            renderContent={() => <Typography variant="paragraphMediumRegular">{text}</Typography>}
            renderActions={renderActions}
        />
    );
};
